import { useState, useEffect, useContext } from 'react';
import { SavedIcon } from "../../StateManagment/SavedIcon";
import { db } from "../../firebase/config.js"

// Normalise the many shapes CompagnyMeta + other docs may hold for a
// boolean-style flag (true, 'true', false, 'false', undefined, '') into a
// strict boolean.
const isTruthyFlag = (v) => v === true || v === 'true'

/**
 * @param {object} props
 * @param {string} props.docid - Document dat de schakelaar bijwerkt
 * @param {string} props.id - Veldnaam die hij schrijft
 * @param {*} props.value - Opgeslagen waarde (boolean of 'true'/'false')
 * @param {string} props.collection - Firestore-collectie
 * @param {() => Promise<boolean>} [props.confirmBeforeOn] - Optioneel: vraagt vóór het
 *   AANzetten of het mag (true = doorgaan). Uitzetten vraagt nooit iets.
 */
const ToggleButton = ({docid, id, value, collection, confirmBeforeOn}) => {
    const [saved, setSaved] = useContext(SavedIcon)
    const [isToggled, setToggled] = useState(isTruthyFlag(value));

    // Sync local state if the incoming value changes (e.g. parent re-fetches).
    useEffect(() => {
      setToggled(isTruthyFlag(value))
    }, [value])

    // Handle toggle event — use local state as the source of truth so we
    // always write a stable 'true' / 'false' string regardless of the
    // stored shape (boolean true, string 'true', undefined, ...).
    const handleToggle = async () => {
      const next = !isToggled
      if (next && confirmBeforeOn && !(await confirmBeforeOn())) return
      setToggled(next)
      saveToDatabase(next ? 'true' : 'false')
    }

     // Save change to database
     const saveToDatabase = (setting) => {
        db.collection(collection)
        .doc(docid)
        .update({
            [id]: setting
        })
        .then(() => {
            setSaved('flex')
         })
    }
  
    return (
      <div className="toggle-container">
        <label className="toggle-switch">
          <input type="checkbox" checked={isToggled} onChange={handleToggle} />
          <span className="slider"></span>
        </label>
      </div>
    );
  }
  
  export default ToggleButton
